export const GET_MOVIES = 'GET_MOVIES'
export const SET_MOVIES = 'SET_MOVIES'
export const UPDATE_MOVIES = 'UPDATE_MOVIES'
export const DELETE_MOVIES = 'DELETE_MOVIES'
export const SET_LOADING = 'SET_LOADING'
export const SET_ERROR = 'SET_ERROR'
export const SET_LOADING_UPDATE = 'SET_LOADING_UPDATE'
export const SET_USERS = 'SET_USERS'
